import {AbstractEditParameterComponent} from "../AbstractEditParameterComponent";

export class EditDollarValue extends AbstractEditParameterComponent {

    static instance = () => Object.assign(AbstractEditParameterComponent.instance(), {
        template: require('./edtDollarValue.html'),
        controller: AbstractEditParameterComponent.controllerInstance.concat([EditDollarValue]),
    });

}